<button mat-icon-button [title]="title" (click)="onClick()">
  <mat-icon class="material-icons-outlined icon-dark" aria-hidden="false" aria-label="Refresh queue" [@rotatedState]='state'>autorenew</mat-icon>
</button>
